import { getChartLabel } from "./chartLabel";
import { useState } from "react";
import { Form } from "react-bootstrap";

//kpi-16
const Support = ({ data, filters, selectedState }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const meetData = data.map((item) => {
    return {
      place: item.Place,
      month: item.Month,
      IEC: item.support_1,
      Displayboards: item.support_2,
      Registers: item.support_3,
      Opertaionlexpenses: item.support_4,
      TAformeeting: item.support_5,
      TAforCounsellors: item.support_6,
    };
  });

  const totalPages = Math.ceil(meetData.length / itemsPerPage);

  const currentData = meetData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const getPageNumbers = () => {
    const pageNumbers = [];
    const delta = 2;

    const range = [];
    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      pageNumbers.push("...");
    }

    pageNumbers.push(...range);

    if (currentPage + delta < totalPages - 1) {
      pageNumbers.push("...");
    }

    return [1, ...pageNumbers, totalPages];
  };

  const showMonth =
    !filters?.StartMonth && !filters?.EndMonth
      ? true // ✅ all months → show
      : filters?.StartMonth !== filters?.EndMonth;

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr d-flex justify-content-between align-items-center">
          <h5 style={{ fontWeight: "bold" }}>
            Support Requested from SACS {getChartLabel(filters, selectedState)}
          </h5>
        </div>
      </div>

      <div className="card hptCard mt-4 border-0">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th className="fw-bold">Place</th>
                {showMonth && <th className="fw-bold">Month</th>}
                <th className="fw-bold text-center">IEC</th>
                <th className="fw-bold text-center">Display Boards</th>
                <th className="fw-bold text-center">Registers</th>
                <th className="fw-bold text-center">Opertaionl Expenses</th>
                <th className="fw-bold text-center">TA for meeting</th>
                <th className="fw-bold text-center">TA for Counsellors</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, idx) => (
                <tr key={idx}>
                  <td style={{ fontWeight: "bold" }}>{item.place}</td>
                  {showMonth && <td>{item.month}</td>}
                  <td>{item.IEC}</td>
                  <td>{item.Displayboards}</td>
                  <td>{item.Registers}</td>
                  <td>{item.Opertaionlexpenses}</td>
                  <td>{item.TAformeeting}</td>
                  <td>{item.TAforCounsellors}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && (
          <div className="card-footer">
            <div className="d-flex justify-content-center mt-3">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    >
                      &laquo;
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        page === currentPage ? "active" : ""
                      } ${page === "..." ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          typeof page === "number" && setCurrentPage(page)
                        }
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Support;
